"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateContactUsReason = translateContactUsReason;
const prismas_1 = require("prismas");
function translateContactUsReason(reason) {
    switch (reason) {
        case prismas_1.ContactUsReason.FINANCIAL_DONATION:
            return 'Financial Donation';
        case prismas_1.ContactUsReason.FURNITURE_DONATION:
            return 'Furniture Donation';
        case prismas_1.ContactUsReason.REFERRAL_PARTNER:
            return 'Referral Partner';
        case prismas_1.ContactUsReason.VOLUNTEERING:
            return 'Volunteering';
        default:
            return 'Other';
    }
}
